module.exports = __webpack_public_path__ + "static/arrow_scroll-6eaf3eea0e182318d687a4af44ac4195.png";